import routingNumberImage from '../images/routing-number.PNG';

// Loan number explanation
export const loanNumberToolTip =
  "<strong>Finding Your Loan Account Number</strong><p>There are a few places you can find your loan account number:</p><ul><li>Monthy Loan Statement</li><li>Loan Payment Coupons</li><li>New Loan Welcome Letter</li><li>Online Banking</li></ul><p>Still can't find it? Call <Strong>888.267.7200</strong></p>";

export const emailToolTip = 
  "<strong>Email Address</strong><p>A payment receipt will be sent to this email address. This email address does not need to match our records.</p>";

export const skipAPayEmailToolTip = 
  "<strong>Email Address</strong><p>A confirmation email will be sent to this email address. This email address does not need to match our records.</p>";

export const cvvToolTip =
"<strong>CVV</strong> <p>Three digit number on the back of your debit card.</p>";

export const travelExemptionToolTip =
"<p>If you do not see your country listed, give us a call at 888-267-7200.</p>";  

export const routingNumberToolTip =
`<img src=${routingNumberImage} style="width: 300px" />`;



// WEBPACK FOOTER //
// ./src/utils/toolTips.js